import AppStorage from './src/ApplicationStorage';
import Auth from './src/Authorisation';
import EncryptionClass from './src/Encryption';
import Elements from './src/FormElements';
import ServerRqst from './src/ServerRequest';
import SetupScript from './src/Setup';
import ContextScript from './src/Context';

export const ApplicationStorage = AppStorage;
export const FormElements = Elements;
export const Encryption = EncryptionClass;
export const Authorisation = Auth;
export const ServerRequest = ServerRqst;
export const Setup = SetupScript;
export const Context = ContextScript;

export default {
    ApplicationStorage: AppStorage,
    Authorisation: Auth,
    Encryption: EncryptionClass,
    FormElements: Elements,
    ServerRequest: ServerRqst,
    Setup: SetupScript,
    Context: ContextScript
};
